import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../../config/global';

// Gets the current locale from browser cookies (client-side only)
export function getLocaleFromCookie(): string {
  // Early return for server-side rendering
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }

  try {
    // Extract locale from cookie
    const cookieMatch = document.cookie.match(/(?:^|; )LOCALE=([^;]*)/);
    
    if (!cookieMatch) {
      return DEFAULT_LOCALE;
    }

    const locale = decodeURIComponent(cookieMatch[1]);

    if (!locale || !SUPPORTED_LOCALES.includes(locale as typeof SUPPORTED_LOCALES[number])) {
      return DEFAULT_LOCALE;
    }

    return locale;
  } catch (error) {
    console.warn('Failed to read locale from cookie:', error);
    return DEFAULT_LOCALE;
  }
}
